<template>
  <b-card title="Salesman Salary">
    <salary-filter @filtersUpdated="filtersChangeHandler" />
    <salary-list :filters="filters" />
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import SalaryList from '@/components/Accounts/Salary/SalaryList.vue'
import SalaryFilter from '@/components/Accounts/Salary/SalaryFilter.vue'

export default {
  components: {
    BCard,
    SalaryList,
    SalaryFilter,
  },
  data() {
    return {
      filters: {},
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
    },
  },
}

</script>
